import mixpanel from 'mixpanel-browser';

mixpanel.init('78ac58423363142495d0700f265146f7', {debug: false});
export default mixpanel; 
